import React from 'react';
import * as FiIcons from 'react-icons/fi';

const SafeIcon = ({ icon, name, className, ...props }) => {
  let IconComponent;
  try {
    IconComponent = icon || (name && FiIcons[`Fi${name}`]);
  } catch (e) {
    IconComponent = FiIcons.FiAlertTriangle;
  }

  if (!IconComponent) IconComponent = FiIcons.FiAlertTriangle;

  return <IconComponent className={className} {...props} />;
};

export default SafeIcon;